import EventEmitter from "events"

// dodging circular imports
export const AutoProcessController = new EventEmitter()
